import { render, staticRenderFns } from "./ProductAlternative.vue?vue&type=template&id=75483d11&scoped=true&"
import script from "./ProductAlternative.vue?vue&type=script&lang=js&"
export * from "./ProductAlternative.vue?vue&type=script&lang=js&"
import style0 from "./ProductAlternative.vue?vue&type=style&index=0&id=75483d11&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75483d11",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VImg})
